import { render, staticRenderFns } from "./GroupListCollecting.vue?vue&type=template&id=5b12bcae&scoped=true"
import script from "./GroupListCollecting.vue?vue&type=script&lang=js"
export * from "./GroupListCollecting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b12bcae",
  null
  
)

export default component.exports